function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m315 77c-130.95 0-238 107.05-238 238s107.05 238 238 238c50.395 0 97.238-15.859 135.81-42.793l100.48 100.48c16.406 16.406 42.984 16.406 59.391 0s16.406-43.012 0-59.391l-100.48-100.48c26.961-38.582 42.793-85.395 42.793-135.79 0-130.95-107.05-238-238-238zm0 84c85.562 0 154 68.441 154 154s-68.441 154-154 154-154-68.441-154-154 68.441-154 154-154z",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.757a0c0719a8ec3ab3aca1c84de382bf.svg";
export { ForwardRef as ReactComponent };